import React from "react";
import WidgetCard from "../../components/WidgetCard/WidgetCard";
import { getGlobalConfiguration } from "../../utils/getGlobalConfiguration";
import { useTranslation } from "react-i18next";
interface PaymentsProps {
  partyId: string;
}

const Payments = ({ partyId }: PaymentsProps) => {
  const { t } = useTranslation();

  const displayedColumnConfiguration = JSON.stringify(
    getGlobalConfiguration("paymentWidget.displayedColumnConfiguration"),
  );
  const translations = JSON.stringify(t("tia-payment-widget:widget.label", { returnObjects: true }));

  const muiGridTranslations = JSON.stringify(
    t("tia-payment-widget:widget.muiGrid", { returnObjects: true, defaultValue: {} }),
  );

  return (
    <WidgetCard style={{ marginTop: "0" }} title={t("widgets.payments.headline")}>
      <ds-payment-widget
        partyid={partyId}
        displayedcolumnconfiguration={displayedColumnConfiguration}
        translations={translations}
        muigridtranslations={muiGridTranslations}
      />
    </WidgetCard>
  );
};

export default Payments;
